import React from "react";
import PropTypes from "prop-types";

const ProtectedRoute = ({ element: Component, permissionName, userPermissions }) => {
  const hasPermission = userPermissions.includes(permissionName);

  //   return hasPermission ? <Component /> : <Navigate to="/" />;
  return hasPermission ? <Component /> : <div>You do not have permission to view this page.</div>;
};

ProtectedRoute.propTypes = {
  element: PropTypes.elementType.isRequired,
  permissionName: PropTypes.string.isRequired,
  userPermissions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProtectedRoute;
